import { connectSearchBox } from 'instantsearch.js/es/connectors';
import BaseComponent from 'scripts/BaseComponent.js';
import GlobalAutocompleteSearchInstance from '../autocomplete-search';

export default class AutocompleteSearchInput extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      form: '.js-searchForm',
      input: '.js-searchInput',
      clearBtn: '.js-searchClear',
      searchQueryText: '.js-searchQueryText',
    };

    this.dom = {
      $component: component,
      $form: this.$get(this.refs.form),
      $input: this.$get(this.refs.input),
      $clearBtns: document.querySelectorAll(this.refs.clearBtn),
      $searchQueryText: document.querySelector(this.refs.searchQueryText),
    };

    this.state = {
      clearSearchActiveClass: 'clear-active',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.addSearchBox();
    this.setOnEventWithElement('keyup', dom.$input, this.setClearBtn);
  }

  addSearchBox() {
    const { dom } = this;
    const customSearchBox = connectSearchBox(this.createSearchBox.bind(this));

    GlobalAutocompleteSearchInstance.search.addWidgets([
      customSearchBox({
        container: dom.$component,
      }),
    ]);
  }

  createSearchBox({ query, refine, clear }, isFirstRender) {
    const { dom } = this;

    if (isFirstRender) {
      this.setOnEventWithElement('input', dom.$input, (input) => refine(input.value));
      this.setClick(Array.from(dom.$clearBtns), () => this.clearInput(clear));
    }

    dom.$searchQueryText.textContent = query;
  }

  setClearBtn(input) {
    const { dom, state } = this;

    if (input.value) {
      dom.$form.classList.add(state.clearSearchActiveClass);
    } else {
      dom.$form.classList.remove(state.clearSearchActiveClass);
    }
  }

  clearInput(clear) {
    const { dom, state } = this;

    clear();
    dom.$input.focus();
    dom.$input.value = '';
    dom.$form.classList.remove(state.clearSearchActiveClass);
  }
}
